/* Gigli - "Limit 3 per order" for sale items (assets/gigli-sale-limit.js). Loaded once from
   snippets/gigli-sale-limit.liquid, which layout/theme.liquid renders on every page.

   Rule (client decision): at most MAX units of EACH sale variant per order, counting one-time purchases
   only. Subscription lines neither count nor get capped, and nothing is limited outside the sale dates.

   Which variants are "on sale" comes from BOGOS's own data, window.fgData.discounts - the same source
   assets/gigli-bogos-price.js reads: an active (start_time..end_time) discount of type "product" lists
   its variants under condition.products[].value[productId].variants[]. BOGOS loads fgData
   asynchronously, so we wait up to 8 s for it. If it never arrives, no limit applies (fails open)
   unless manual variant IDs are set in the snippet.

   Covered:
     - product page and quick-buy pop-up: the pack stepper stops at MAX for a one-time sale variant
       (re-checked on every variant change and on Recharge's one-time / subscribe toggle),
     - every add-to-cart form (product page, card quick add, quick-buy pop-up): checks /cart.js first and
       blocks with "Limit 3 per order" if the total would go over,
     - the /cart page: one-time sale lines cannot be raised above MAX, typed values are corrected.
   NOT covered: the Recharge cart drawer (its own +/- and upsell buttons). Recharge renders it in its own
   shadow DOM and adds to the cart itself, so the theme cannot intercept it. Accepted by the client.
   Checkout itself does not enforce the limit either. */
(function () {
  "use strict";
  if (window.GigliSaleLimit) return;

  var CFG = { max: 3, manualVariantIds: "" };
  try {
    var el = document.getElementById("gigli-sale-limit-config");
    if (el) CFG = Object.assign(CFG, JSON.parse(el.textContent));
  } catch (e) {}
  var MAX = parseInt(CFG.max, 10) || 0;
  if (MAX <= 0) return;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";

  /* ------------------------------------------------------------ which variants are on sale */

  /* BOGOS timestamps carry microseconds, which not every engine parses; trim to milliseconds. */
  function when(t) {
    return t ? Date.parse(String(t).replace(/(\.\d{3})\d+/, "$1")) : NaN;
  }

  /* Variant ids of the BOGOS product discounts active right now, or null if BOGOS has not loaded. */
  function fromBogos() {
    var fg = window.fgData;
    if (!fg || !Array.isArray(fg.discounts)) return null;
    var now = Date.now();
    var ids = {};
    fg.discounts.forEach(function (d) {
      if (!d || d.type !== "product") return;
      var from = when(d.start_time),
        to = when(d.end_time);
      if (!isNaN(from) && now < from) return;
      if (!isNaN(to) && now > to) return;
      var groups = d.condition && d.condition.products;
      if (!Array.isArray(groups)) return;
      groups.forEach(function (g) {
        var byProduct = g && g.value;
        if (!byProduct || typeof byProduct !== "object") return;
        Object.keys(byProduct).forEach(function (key) {
          var entry = byProduct[key];
          if (!entry || !Array.isArray(entry.variants)) return;
          entry.variants.forEach(function (v) {
            if (v && v.id != null) ids[String(v.id)] = true;
          });
        });
      });
    });
    return ids;
  }

  function manualIds() {
    var ids = {};
    String(CFG.manualVariantIds || "")
      .split(",")
      .map(function (s) { return s.trim(); })
      .filter(Boolean)
      .forEach(function (id) { ids[id] = true; });
    return ids;
  }

  function saleIds() {
    var bogos = fromBogos();
    if (bogos && Object.keys(bogos).length) return bogos;
    return manualIds(); /* empty unless set in the snippet -> no limit */
  }
  function isSale(variantId) {
    return !!saleIds()[String(variantId)];
  }

  /* Resolves once fgData is there, or after 8 s (then the limit simply does not apply). */
  var readyPromise = new Promise(function (resolve) {
    if (window.fgData && Array.isArray(window.fgData.discounts)) return resolve();
    var waited = 0;
    var t = setInterval(function () {
      waited += 250;
      if ((window.fgData && Array.isArray(window.fgData.discounts)) || waited >= 8000) {
        clearInterval(t);
        resolve();
      }
    }, 250);
  });

  /* ------------------------------------------------------------ helpers */

  function isOneTime(form) {
    var plan = form.querySelector('[name="selling_plan"]');
    return !plan || !plan.value;
  }
  function addForms() {
    return Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]'));
  }
  function fetchCart() {
    return fetch(ROOT + "cart.js", { headers: { Accept: "application/json" } }).then(function (r) {
      return r.json();
    });
  }
  function oneTimeQuantityInCart(cart, variantId, exceptKey) {
    return (cart.items || []).reduce(function (sum, item) {
      if (String(item.variant_id) !== String(variantId) || item.selling_plan_allocation || item.key === exceptKey) return sum;
      return sum + item.quantity;
    }, 0);
  }
  function limitText() {
    return "Limit " + MAX + " per order";
  }

  function injectStyles() {
    if (document.getElementById("gigli-sale-limit-styles")) return;
    var style = document.createElement("style");
    style.id = "gigli-sale-limit-styles";
    /* Same red as the theme's cart error line (assets/theme.js line-item error icon #bf1515). */
    style.textContent = ".gigli-sale-limit{color:#bf1515;font-size:14px;font-weight:500;line-height:20px;margin:8px 0 0;text-align:center}";
    document.head.appendChild(style);
  }

  /* ------------------------------------------------------------ 1. stepper on product page / pop-up */

  function capForm(form) {
    var idInput = form.querySelector('[name="id"]');
    var qty = form.querySelector('input.quantity__input[name="quantity"]');
    if (!idInput || !qty) return;
    if (!("gigliLimitMax" in qty.dataset)) qty.dataset.gigliLimitMax = qty.getAttribute("max") || "";
    var original = qty.dataset.gigliLimitMax;
    if (isSale(idInput.value) && isOneTime(form)) {
      var max = original && parseInt(original, 10) > 0 ? Math.min(MAX, parseInt(original, 10)) : MAX;
      if (qty.getAttribute("max") !== String(max)) qty.setAttribute("max", max);
      if (parseInt(qty.value, 10) > max) qty.value = max;
    } else if (qty.getAttribute("max") !== original) {
      if (original) qty.setAttribute("max", original);
      else qty.removeAttribute("max");
    }
  }
  function capAll() {
    addForms().forEach(capForm);
  }

  /* gigli-bundle.js changes the variant id and the stepper value in its own handlers, and Recharge's
     one-time / subscribe toggle only reaches us as a click on its widget. Re-check after all of them. */
  function recheckSoon(event) {
    var form = event.target && event.target.closest && event.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    setTimeout(function () { capForm(form); }, 0);
    setTimeout(function () { capForm(form); }, 300);
  }
  document.addEventListener("click", recheckSoon, true);
  document.addEventListener("change", function (event) {
    var form = event.target && event.target.closest && event.target.closest('form[action*="/cart/add"]');
    if (form) hideMessage(form);
    recheckSoon(event);
  }, true);

  /* ------------------------------------------------------------ 2. every add to cart */

  function showMessage(form, text) {
    var p = form.querySelector(".gigli-sale-limit");
    if (!p) {
      p = document.createElement("p");
      p.className = "gigli-sale-limit";
      p.setAttribute("role", "alert");
      var button = form.querySelector('[type="submit"]');
      /* Under the stepper + button row, not inside it (that row is a flex line). */
      var row = button && (button.closest(".submit-wrapper") || button.parentNode);
      if (row && row.parentNode) row.parentNode.insertBefore(p, row.nextSibling);
      else form.appendChild(p);
    }
    p.textContent = text;
  }
  function hideMessage(form) {
    var p = form.querySelector(".gigli-sale-limit");
    if (p) p.remove();
  }

  /* Capture phase on document runs before the theme's own submit handler (Prestige product-form). If
     the add is allowed, the form is submitted again untouched and this handler lets it through. */
  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (form.dataset.gigliLimitChecked === "1") {
      delete form.dataset.gigliLimitChecked;
      return;
    }
    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !isOneTime(form)) return;
    /* Before BOGOS data is in we cannot tell, so hold the submit until it is (max 8 s). */
    var known = window.fgData && Array.isArray(window.fgData.discounts);
    if (known && !isSale(idInput.value)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    hideMessage(form);
    var submitter = event.submitter;
    var wanted = parseInt((form.querySelector('[name="quantity"]') || {}).value || "1", 10) || 1;

    function resubmit() {
      form.dataset.gigliLimitChecked = "1";
      if (form.requestSubmit) form.requestSubmit(submitter && submitter.form === form ? submitter : undefined);
      else form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
    }

    readyPromise
      .then(function () {
        if (!isSale(idInput.value)) return resubmit();
        return fetchCart().then(function (cart) {
          var already = oneTimeQuantityInCart(cart, idInput.value);
          if (already + wanted > MAX) {
            injectStyles();
            showMessage(form, limitText() + (already ? " (" + already + " already in your cart)" : ""));
            return;
          }
          resubmit();
        });
      })
      .catch(resubmit); /* cart unreadable: never block a sale on our own error */
  }, true);

  /* ------------------------------------------------------------ 3. /cart page */

  var cartState = null;
  function allowedFor(key) {
    if (!cartState) return null;
    var item = (cartState.items || []).filter(function (i) { return i.key === key; })[0];
    if (!item || item.selling_plan_allocation || !isSale(item.variant_id)) return null;
    return Math.max(0, MAX - oneTimeQuantityInCart(cartState, item.variant_id, key));
  }
  function applyCartCaps() {
    document.querySelectorAll("input[data-line-key]").forEach(function (input) {
      var allowed = allowedFor(input.getAttribute("data-line-key"));
      if (allowed !== null) input.setAttribute("max", allowed);
    });
  }
  function cartMessage(near) {
    injectStyles();
    var box = near.closest("line-item-quantity") || near.parentNode;
    var p = box.parentNode.querySelector(".gigli-sale-limit");
    if (!p) {
      p = document.createElement("p");
      p.className = "gigli-sale-limit";
      p.setAttribute("role", "alert");
      box.parentNode.insertBefore(p, box.nextSibling);
    }
    p.textContent = limitText();
  }
  /* "+" on the cart page is a /cart/change link handled by the theme's line-item-quantity. */
  document.addEventListener("click", function (event) {
    var link = event.target.closest && event.target.closest('a[href*="/cart/change"]');
    if (!link) return;
    var url = new URL(link.href, location.origin);
    var allowed = allowedFor(url.searchParams.get("id"));
    if (allowed !== null && parseInt(url.searchParams.get("quantity"), 10) > allowed) {
      event.preventDefault();
      event.stopImmediatePropagation();
      cartMessage(link);
    }
  }, true);
  /* Typed quantities: corrected before the theme sends them. */
  document.addEventListener("change", function (event) {
    var input = event.target;
    if (!input.matches || !input.matches("input[data-line-key]")) return;
    var allowed = allowedFor(input.getAttribute("data-line-key"));
    if (allowed !== null && parseInt(input.value, 10) > allowed) {
      input.value = allowed;
      cartMessage(input);
    }
  }, true);
  document.addEventListener("cart:change", function (event) {
    if (event.detail && event.detail.cart) {
      cartState = event.detail.cart;
      applyCartCaps();
    }
  });

  /* ------------------------------------------------------------ start */

  readyPromise.then(function () {
    capAll();
    if (document.querySelector("input[data-line-key]")) {
      fetchCart().then(function (c) { cartState = c; applyCartCaps(); }).catch(function () {});
    }
  });
  /* The quick-buy pop-up is inserted later; check new forms as they appear. */
  var pending = null;
  new MutationObserver(function () {
    if (pending) return;
    pending = setTimeout(function () { pending = null; capAll(); }, 300);
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.GigliSaleLimit = { max: MAX, isSale: isSale, saleIds: saleIds, refresh: function () { capAll(); applyCartCaps(); } };
})();
